import { AfterContentInit, Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ScanData } from 'src/app/interfaces';
import {
  ScannerQRCodeConfig,
  ScannerQRCodeSelectedFiles,
  NgxScannerQrcodeService,
  ScannerQRCodeResult,
  NgxScannerQrcodeComponent
} from 'ngx-scanner-qrcode';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute } from '@angular/router';



@Component({
  selector: 'app-scan-dialog',
  templateUrl: './scan-dialog.component.html',
  styleUrls: ['./scan-dialog.component.scss']
})
export class ScanDialogComponent implements OnInit {

  data: ScanData = { url: `${location.origin}/api/v1/los/shipper-corp/piece0000` }

  // https://developer.mozilla.org/en-US/docs/Web/API/MediaDevices/getUserMedia
  public config: ScannerQRCodeConfig = {
    // fps: 1000,
    vibrate: 400,
    // isBeep: true,
    // decode: 'macintosh',
    deviceActive: 1,
    constraints: {
      audio: false,
      video: {
        width: window.innerWidth
      }
    }
  };

  public qrCodeResult: ScannerQRCodeSelectedFiles[] = [];

  @ViewChild('action') action!: NgxScannerQrcodeComponent;


  constructor(private dialogRef: MatDialogRef<ScanDialogComponent>, @Inject(MAT_DIALOG_DATA) data: ScanData,
    private qrcode: NgxScannerQrcodeService, private snackBar: MatSnackBar, private route: ActivatedRoute) { }

  ngAfterContentInit(): void {
    setTimeout(() => this.action.start(), 1);
    this.dialogRef.afterClosed().subscribe(() => this.action.stop());
  }

  public onEvent(arr: ScannerQRCodeResult[]): void {
    if (arr.length > 0) {
      const url = arr[0].value;
      try {
        new URL(url);
        this.data.url = url;
        this.close();
      } catch (error) {
        this.snackBar.open(`Invalid URL ${url}`, undefined, { duration: 1500 });
      }
    }
  }

  ngOnInit(): void {
  }

  close(): void {
    this.dialogRef.close(this.data);
  }


}
